export const DCO_ITEM_PERFORMANCE_REPORT_ID = 'dco-item-performance';
